import type { SchedulerRef } from '@lmt/unicorn-shared/app/common/devexpress/Scheduler/dx-scheduler';
import { FC, RefObject, useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';

import styles from './PortalToTable.module.scss';

function findSchedulerTable(scheduler: RefObject<SchedulerRef>) {
  const instance = scheduler.current?.instance;
  const elem = (instance?.().$element() as any)[0];
  const scrollable = elem
    ?.getElementsByClassName('dx-scheduler-date-table-scrollable')
    .item(0)
    ?.getElementsByClassName('dx-scrollable-content')
    ?.item(0);

  return scrollable;
}

export const PortalToTable: FC<
  React.PropsWithChildren<{
    schedulerRef: RefObject<SchedulerRef>;
  }>
> = (props) => {
  const { children, schedulerRef } = props;

  const portalRoot = useMemo(() => {
    const htmlDivElement = document.createElement('div');
    htmlDivElement.className = styles.portalRoot;
    return htmlDivElement;
  }, []);

  const [rootAppended, setRootAppended] = useState(false);
  useEffect(() => {
    const table = findSchedulerTable(schedulerRef);
    table?.appendChild(portalRoot);
    setRootAppended(true);
  }, [schedulerRef.current, setRootAppended]);

  return rootAppended
    ? ReactDOM.createPortal(children as any, portalRoot)
    : null;
};
